import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from "@angular/material/dialog";
import { AppState } from "src/app/app.reducer";
import { Store } from "@ngrx/store";
import {
  GetSharedUsersList,
  ShareDocumentToMembers,
  EditUserPermissionForDoc,
  RemoveUserForDoc
} from "../_store/resources.actions";
import { NotificationComponent } from "angular2-notifications";
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { tap } from "rxjs/operators";

@Component({
  selector: "share-document",
  templateUrl: "./share-document.component.html",
  styleUrls: ["./share-document.component.scss"]
})
export class ShareDocumentComponent implements OnInit {
  collaborators = [];
  viewers = [];
  documentId;
  sharedUsers$;
  selectedMembers: any = [];
  permission = "viewer";
  userCapability: Array<string> = [];
  permissionArray = [
    {
      viewLabel: "Can Edit",
      value: "collaborator"
    },
    {
      viewLabel: "Can View",
      value: "viewer"
    }
  ];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ShareDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store: Store<AppState>
  ) {
    console.log(data, "data");
    this.dialogRef.disableClose = true;
    this.documentId = data.documentId;
    // this.docPermission = data.documentPermission;
  }

  ngOnInit() {
    this.store.dispatch(new GetSharedUsersList(this.documentId));
    this.sharedUsers$ = this.store
      .select(state => state.resources.sharedUsers)
    // .pipe(
    //   tap(a => {
    //     console.log(a, "chect data");
    //   })
    // );
    this.store
      .select(state => state.resources.userCapability)
      .subscribe(data => {
        this.userCapability = data;
      });
  }

  onNoClick(): void {
    this.dialogRef.close("");
  }

  getMembers(event) {
    this.selectedMembers = event.selectedItems;
  }

  onPermissionChange(event) {
    this.permission = event.value;
  }

  doShare() {
    if (this.selectedMembers.length) {
      this.store.dispatch(
        new ShareDocumentToMembers(
          this.documentId,
          this.permission,
          this.selectedMembers
        )
      );
      this.dialogRef.close();
    }
  }

  onEditUserPermission(event: any, user: any) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "40%",
      panelClass: 'cmp-modal',
      data: {
        text: "Are you sure you want to change the existing permissions of this document?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(
          new EditUserPermissionForDoc(
            this.documentId,
            user.type,
            user.id,
            event.value
          )
        );
        this.dialogRef.close();
      } else {
        this.store.dispatch(new GetSharedUsersList(this.documentId));
      }
    });
  }

  removeUser(user: any) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "40%",
      panelClass: 'cmp-modal',
      data: {
        text: "Are you sure you want to remove access? "
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(
          new RemoveUserForDoc(
            this.documentId,
            user.type,
            user.id,
            user.docRole
          )
        );
        this.dialogRef.close();

      }
    });
  }
}
